import { LoggerService } from './services/logger.service';
import { NgModule } from '@angular/core';

@NgModule({
  providers: [
    LoggerService
  ],
  declarations: [
  ],
  exports: [
  ]
})
export class LoggerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/logger.module.ts